/**
 * Shimmer — zero-layout-shift loading placeholder.
 * Give it explicit dimensions via className; height matches the real card/tile.
 *
 * Example:
 *   <Shimmer className="h-[120px]" />
 *   <Shimmer className="h-5 w-1/2" />
 */
import React from "react";

export function Shimmer({ className = "", ...rest }) {
  return <div className={`shimmer ${className}`} {...rest} />;
}
